import PropTypes from 'prop-types'
import { Component } from 'react'

import { LocationWidget } from './styles'


export class MapWidget extends Component {
  static propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    address: PropTypes.string,
    phone: PropTypes.string,
    photo: PropTypes.string,
    className: PropTypes.string,
    closed: PropTypes.bool,
    onPress: PropTypes.func
  }

  static defaultProps = {
    lat: undefined,
    lng: undefined,
    onPress: () => {},
    className: '',
    photo: '',
    phone: '',
    address: '',
    closed: false
  }

  render() {
    const {
      className, phone, address, onPress, lat, lng, photo, closed
    } = this.props
    return (
      <LocationWidget lat={lat} lng={lng} className={className}>
        <button
          className="locationButton"
          onClick={() => {
            onPress()
          }}
        >
          <img
            className="locationSvg"
            src="/static/images/location.svg"
            alt=""
          />
        </button>
        {!closed && (
          <>
            <img className="locationLogo" src={photo || '/static/images/empty-place.svg'} alt="" />
            <div className="address">
              <span>{address}</span>
              <span>{phone}</span>
            </div>
          </>
        )}
      </LocationWidget>
    )
  }
}
